var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-control-pages-navigation-container" }, [
    _setup.other
      ? _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.otherValue,
                      expression: "otherValue",
                    },
                  ],
                  ref: "inputRef",
                  staticClass: "form-control",
                  class: {
                    "form-control-sm": _setup.formSmall,
                    "is-invalid": _vm.field.error,
                  },
                  attrs: { type: "text", placeholder: "Submit your new value" },
                  domProps: { value: _setup.otherValue },
                  on: {
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _setup.hideOtherForm.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _setup.applyOtherValue.apply(null, arguments)
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _setup.otherValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    class: {
                      "btn-sm": _setup.formSmall,
                      "btn-warning": _setup.otherValue.length > 0,
                    },
                    attrs: { "default-class": "btn-primary" },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.applyOtherValue.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi-arrow-return-left" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              _setup.Button,
              {
                class: { "btn-sm": _setup.formSmall },
                attrs: { "default-class": "btn-link" },
                nativeOn: {
                  click: function ($event) {
                    return _setup.hideOtherForm.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "bi-x-lg" })]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_setup.other,
            expression: "!other",
          },
        ],
        staticClass: "dropdown",
      },
      [
        _c(
          _setup.Button,
          {
            ref: "dropdownButtonRef",
            staticClass: "dropdown-toggle border",
            class: { "btn-sm": _setup.formSmall },
            attrs: {
              id: _setup.dropdownId,
              "aria-expanded": "true",
              "data-bs-toggle": "dropdown",
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.currentData[_vm.field.name] || "Select group…") +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": _setup.dropdownId },
          },
          [
            _vm._l(_setup.navigationGroups, function (group) {
              return _c("li", { key: group }, [
                _c(
                  "span",
                  {
                    staticClass: "dropdown-item",
                    class: {
                      active: group === _vm.currentData[_vm.field.name],
                      small: _setup.formSmall,
                    },
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        return _setup.setValue(group)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(group) +
                        "\n                "
                    ),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                {
                  staticClass: "dropdown-item",
                  class: { small: _setup.formSmall },
                  attrs: { role: "button" },
                  on: { click: _setup.showOtherForm },
                },
                [_vm._v("\n                    Other…\n                ")]
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [_c("hr", { staticClass: "dropdown-divider" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }